import { ReactNode } from "react";

interface PageHeroProps {
  /** Small botanical eyebrow — e.g. "🌿 Executive Desk". */
  eyebrow: ReactNode;
  /** The single warm sentence. First-person from the Assistant, addressed to the Director. */
  title: ReactNode;
  /** One short supporting line, no more. */
  subtitle?: ReactNode;
  /** Optional right-side actions. Keep to ONE primary + at most one ghost. */
  actions?: ReactNode;
}

/**
 * The single canonical page hero. Every admin page opens with this exact shape
 * so the muscle memory transfers page to page. See:
 *   - mem/constitution/silver-sage-north-star.md (Five-Second Rule)
 *   - mem/features/executive-office-constitution.md
 */
export function PageHero({ eyebrow, title, subtitle, actions }: PageHeroProps) {
  return (
    <header className="flex items-start justify-between gap-4 flex-wrap pt-1">
      <div className="space-y-1.5 min-w-0">
        <div className="eyebrow flex items-center gap-2">{eyebrow}</div>
        <h1 className="font-heading text-3xl md:text-4xl text-foreground leading-tight tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-muted-foreground max-w-2xl">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </header>
  );
}
